export default {
  // Member Churn List
  'memberChurn.title': 'Member Churn List',
  'memberChurn.vipLevels': 'VIP Levels',
  'memberChurn.caliberDescription': 'Caliber Description',
  'memberChurn.search': 'Search',
  'memberChurn.reset': 'Reset',
  'memberChurn.export': 'Export',
  'memberChurn.memberAccount': 'Member Account',
  'memberChurn.realName': 'Member Real Name',
  'memberChurn.memberName': 'Member Nickname',
  'memberChurn.agentAccount': 'Superior Agent Account',
  'memberChurn.registerInfo': 'Registration Info',
  'memberChurn.registerTime': 'Registration Time',
  'memberChurn.registerIp': 'Registration IP',
  'memberChurn.rechargeCount': 'Recharge Count',
  'memberChurn.withdrawCount': 'Withdraw Count',
  'memberChurn.totalRecharge': 'Total Recharge (Multi-currency)',
  'memberChurn.totalWithdraw': 'Total Withdraw',
  'memberChurn.firstRechargeTime': 'First Recharge Time',
  'memberChurn.lastRechargeTime': 'Last Recharge Time',
  'memberChurn.lastRechargeStartTime': 'Last Recharge Time (Start)',
  'memberChurn.lastRechargeEndTime': 'Last Recharge Time (End)',
'memberChurn.lastLoginTime': 'Last Login Time',
'memberChurn.lastBettingTime': 'Last Betting Time',
  'memberChurn.action': 'Action',
  'memberChurn.view': 'View',
  'memberChurn.noData': 'No data',
  'memberChurn.defaultEmpty': 'Please select search conditions',
  'memberChurn.requestFailed': 'Request failed',
  'memberChurn.export.loading': 'Exporting data...',
  'memberChurn.export.success': 'Export successful',
  'memberChurn.export.failed': 'Export failed',
  'memberChurn.timeRangeWarning': 'Please select time range',
  'memberChurn.startTime': 'Recent Recharge Time (Start)',
  'memberChurn.endTime': 'Recent Recharge Time (End)',
  'memberChurn.timeRangeError': 'Start time cannot be later than end time',
  'memberChurn.depositTimeQueryTip': '[Recommend selecting recent recharge time for query first]',
  'memberChurn.caliberTooltip': 'Churn Caliber: Only judged by recharge. Filter users whose "last successful recharge falls within the selected time period and have no new recharges since then"; Default display: Users who have not recharged for 3 days (end time = today - 3 days, start time left empty); Common usage: Only fill in "end time" → Find users whose "last recharge ≤ that date and no new recharge until now"; Fill in both "start + end" → Find users whose "last recharge is within the range and no new recharge until now"; Only fill in "start time" → Find users whose "last recharge ≥ that date and no new recharge until now"; Example: Today 8/27, select end time 8/24 → Filter users whose last recharge was on or before 8/24 and had no recharge from 8/25–8/27. Select time range 8/1–8/7 → Filter users whose last recharge was between 8/1–8/7 and had no recharge from 8/8–8/27. Note: Login/betting does not affect churn judgment.',
  'member.detail.search.memberAccount': 'Member Account',
  'member.detail.search.placeholder': 'Enter member account / phone / email',
  'member.detail.search.button': 'Search',
  'member.detail.search.refresh': 'Refresh',
  'member.detail.search.notFound': 'Member information not found',
  'member.detail.search.error': 'Service error',
  'member.detail.tabs.basicInfo': 'Basic Info',
  'member.detail.tabs.accountInfo': 'Account Info',
  'member.detail.tabs.mainAccountTrade': 'Main Account Trade',
  'member.detail.tabs.recentBets': 'Recent Bets',
  'member.detail.tabs.promotionInfo': 'Promotion Info',
  'member.detail.tabs.memberPoints': 'Member Points',
  'member.detail.tabs.gameAccountTrade': 'Game Account Trade',
  'member.detail.tabs.riskControl': 'Risk Control Information',
  'member.detail.tabs.badDebt': 'Bad Debt Records',
  'member.detail.tabs.regulatoryReport': 'Game Route Status',
  'member.detail.regulatoryReport.statusLabel': 'Status',
  'member.detail.regulatoryReport.statusReporting': 'Reporting',
  'member.detail.regulatoryReport.statusClosed': 'Reporting closed',
  'member.detail.regulatoryReport.closeButton': 'Disable data reporting',
  'member.detail.regulatoryReport.closeButtonHint': 'Prerequisites are checked in real time when clicked',
  'member.detail.regulatoryReport.precheckTitle': 'Pre-check before closing reporting',
  'member.detail.regulatoryReport.precheckBanner': 'The following issues were detected; closing is not allowed:',
  'member.detail.regulatoryReport.precheckOk': 'OK, try again later',
  'member.detail.regulatoryReport.check.deposit.ok': 'No pending deposit orders',
  'member.detail.regulatoryReport.check.deposit.fail': 'The user has pending deposit orders, please try again later',
  'member.detail.regulatoryReport.check.withdraw.ok': 'No pending payout withdrawal orders',
  'member.detail.regulatoryReport.check.withdraw.fail': 'The user has pending payout withdrawal orders, please try again later',
  'member.detail.regulatoryReport.check.unsettledBet.ok': 'No pending settlement bet orders',
  'member.detail.regulatoryReport.check.unsettledBet.fail': 'The user has pending settlement bet orders, please try again later',
  'member.detail.regulatoryReport.check.recentBet.ok': 'No in-progress gaming activity (no bets in the last 10 minutes)',
  'member.detail.regulatoryReport.check.recentBet.fail': 'The user has bets in the last 10 minutes, please try again later',
  'member.detail.regulatoryReport.ordersDetail': 'Order no.: {orders}',
  'member.detail.regulatoryReport.reasonTitle': 'Reason for closing reporting',
  'member.detail.regulatoryReport.reasonPlaceholder': 'Enter the reason',
  'member.detail.regulatoryReport.reasonRequired': 'Please enter a reason',
  'member.detail.regulatoryReport.confirmClose': 'Confirm close',
  'member.detail.regulatoryReport.applySuccess': 'Data reporting has been disabled',
  'member.detail.regulatoryReport.applyFail': 'Failed to close',
  'member.detail.regulatoryReport.precheckFail': 'Pre-check failed',

  'member.closeReportUser.title': 'Game Route Change Log',
  'member.closeReportUser.subtitle': 'Only users whose PAGCOR data reporting has been closed are listed; export is supported.',
  'member.closeReportUser.memberAccount': 'Member account',
  'member.closeReportUser.memberAccountPh': 'Member account',
  'member.closeReportUser.closeTimeRange': 'Closed reporting time',
  'member.closeReportUser.closeTime': 'Closed reporting time',
  'member.closeReportUser.operatorName': 'Operator',
  'member.closeReportUser.operatorPh': 'Operator account',
  'member.closeReportUser.operationReason': 'Operation reason',

  'member.reportStatus.detail.title': 'Report Status',
  'member.reportStatus.detail.currentTitle': 'Current Status',
  'member.reportStatus.detail.currentStatus': 'Current report_status',
  'member.reportStatus.detail.latestSwitch': 'Last Switch',
  'member.reportStatus.detail.switchReason': 'Switch Reason',
  'member.reportStatus.detail.toggleBtn': 'Switch Game Route',
  'member.reportStatus.detail.historyTitle': 'Switch History',
  'member.reportStatus.col.time': 'Time',
  'member.reportStatus.col.type': 'Type',
  'member.reportStatus.col.statusChange': 'Status Change',
  'member.reportStatus.col.operator': 'Operator',
  'member.reportStatus.col.reason': 'Reason',
  'member.reportStatus.col.remark': 'Remark',
  'member.reportStatus.status.reported': 'Route A',
  'member.reportStatus.status.notReported': 'Route B',
  'member.reportStatus.type.registerAuto': 'Auto (Register)',
  'member.reportStatus.type.manual': 'Manual',
  'member.reportStatus.type.autoThreshold': 'Deposit Reached',
  'member.reportStatus.type.autoVip': 'VIP Reached',
  'member.reportStatus.reasonLabel.REGISTER_AUTO': 'Registration ratio tagging',
  'member.reportStatus.reasonLabel.AUTO_THRESHOLD': 'Cumulative deposit met',
  'member.reportStatus.reasonLabel.AUTO_VIP': 'VIP level met',
  'member.reportStatus.modal.title': 'Switch Game Route',
  'member.reportStatus.modal.memberAccount': 'Member Account',
  'member.reportStatus.modal.statusChange': 'Status Change',
  'member.reportStatus.modal.reason': 'Switch Reason',
  'member.reportStatus.modal.remark': 'Remark',
  'member.reportStatus.modal.remarkPh': 'Optional detailed reason for audit',
  'member.reportStatus.modal.reasonPh': 'Required. Please state the reason (e.g. internal test account / account recycling / mis-onboarded user / special approval, etc.)',
  'member.reportStatus.modal.confirm': 'Confirm',
  'member.reportStatus.modal.cancel': 'Cancel',
  'member.reportStatus.modal.reasonRequired': 'Please select a switch reason',
  'member.reportStatus.modal.backupTip': 'After switching, the system will back up the user\'s current bet_record to bet_record_bak (for audit). Effective from the next game round.',
  'member.reportStatus.reason.arbitrage': 'Arbitrage account confirmed',
  'member.reportStatus.reason.channel': 'Channel attribution conflict',
  'member.reportStatus.reason.internal': 'Internal test account',
  'member.reportStatus.reason.riskUser': 'Risk-control user',
  'member.reportStatus.reason.other': 'Other (please add remark)',
  'member.reportStatus.toggleSuccess': 'Switched successfully',
  'member.reportStatus.toggleFail': 'Switch failed',
  'member.reportStatus.fetchError': 'Failed to load',
  'member.reportStatus.list.title': 'Report Status Management',
  'member.reportStatus.list.subtitle': 'Both auto-closed at registration and manually modified members are shown here.',
  'member.reportStatus.list.statusAll': 'All',
  'member.reportStatus.list.memberAccount': 'Member Account',
  'member.reportStatus.list.status': 'Current Status',
  'member.reportStatus.list.switchTimeRange': 'Last Switch Time',
  'member.reportStatus.list.switchTime': 'Last Switch Time',
  'member.reportStatus.list.operator': 'Operator',
  'member.reportStatus.list.reason': 'Switch Reason',
  'member.reportStatus.list.detail': 'Detail',
  'member.reportStatus.list.search': 'Search',
  'member.reportStatus.list.reset': 'Reset',
  'member.reportStatus.list.export': 'Export',

  'member.detail.index.summary': 'Summary Information',
  'member.detail.index.lastLogin': 'Last 10 Login Information',
  'member.detail.index.certification': 'Certification Documents',
  'member.detail.index.vipInfo': 'VIP Information',
  'member.detail.index.manualTags': 'Member Tags',
  'member.detail.index.remarks': 'Remarks',
  'member.detail.modal.addRemark.title': 'Add Note',
  'member.detail.modal.agent.title': 'Modify Superior Agent',
  'member.detail.modal.agent.currentAgent': 'Current Superior Agent:',
  'member.detail.modal.agent.operationType': 'Select Operation Type:',
  'member.detail.modal.agent.modifyAgent': 'Modify Superior Agent',
  'member.detail.modal.agent.removeAgent': 'Remove Superior Agent',
  'member.detail.modal.agent.targetAgent': 'Target Agent:',
  'member.detail.modal.agent.remark': 'Remark:',
  'member.detail.modal.agent.cancel': 'Cancel',
  'member.detail.modal.agent.confirm': 'Confirm',
  'member.detail.modal.agent.inputPlaceholder': 'Please input',
  'member.detail.modal.agent.agentNotExist': 'Specified agent does not exist!',
  'member.detail.modal.agent.inputAgentAccount': 'Please input agent account',
  'member.detail.modal.agent.success': 'Operation successful',
  'member.detail.modal.agent.error': 'Operation failed',
  'member.detail.modal.inviter.title': 'Add Inviter',
  'member.detail.modal.inviter.currentInviter': 'Current Inviter:',
  'member.detail.modal.inviter.operationType': 'Select Operation Type:',
  'member.detail.modal.inviter.selectOperationType': 'Please select operation type',
  'member.detail.modal.inviter.modifyInviter': 'Modify Inviter',
  'member.detail.modal.inviter.removeInviter': 'Remove Inviter',
  'member.detail.modal.inviter.targetInviter': 'Specify Inviter:',
  'member.detail.modal.inviter.inputInviterAccount': 'Please enter inviter account',
  'member.detail.modal.inviter.inputPlaceholder': 'Please enter',
  'member.detail.modal.inviter.inputHint': 'You can enter the inviter account/UID',
  'member.detail.modal.inviter.remark': 'Remarks/Notes:',
  'member.detail.modal.inviter.cancel': 'Cancel',
  'member.detail.modal.inviter.confirm': 'Confirm',
  'member.detail.modal.inviter.success': 'Operation successful',
  'member.detail.modal.inviter.error': 'Operation failed',
  'member.detail.modal.inviter.inviterNotExist': 'Inviter does not exist',
  'member.detail.modal.inviter.noInviter': 'No Inviter',

  // Member List Page
  'memberList.title': 'Member List',
  'memberList.searchWarning': 'Due to large data volume, please combine 1 or more conditions to query data',
  'memberList.exportWarning': 'Please select at least 3 query condition to export',
  'memberList.timeConditionWarning': 'When selecting first recharge time or last recharge time, please also select currency',
  'memberList.dataExceedWarning': 'Your query data has exceeded 1000 items, please use export function to export the data you need',
  'memberList.exportExceedWarning': 'Your export data has exceeded 10000 items, please adjust filter conditions',
  'memberList.notes': 'Page comes with no data by default, table shows no data',
  'memberList.defaultEmpty': 'No data',
  'memberList.registerTime': 'Registration Time',
  'memberList.firstRechargeTime': 'First Recharge Time',
  'memberList.lastRechargeTime': 'Last Recharge Time',
  'memberList.lastLoginTime': 'Last Login Time',
  'memberList.mobileProvider': 'Mobile Provider',
  'memberList.mobileProviderPlaceholder': 'Select Mobile Provider',
  'memberList.mobileValid': 'Mobile Verification Status',
  'memberList.mobileValidPlaceholder': 'Please select mobile verification status',
  'memberList.mobileValid.verified': 'Verified',
  'memberList.mobileValid.unverified': 'Unverified',
  'memberList.isAgent': 'Has Superior Gaming Venue',
  'memberList.hasAgent': 'Has Gaming Venue',
  'memberList.noAgent': 'No Gaming Venue',
  'memberList.agentAccount': 'Gaming Venue Account',
  'memberList.agentType': 'Gaming Venue Type',
  'memberList.agentTag': 'Gaming Venue Tag',
  'memberList.topAgent': 'Top-Level Gaming Venue',
  'memberList.agentAccountAllUnderL1': 'All under this L1',
  'memberList.agentAccountSelectL1First': 'Select a top-level gaming venue first',
  'memberList.defaultAgent': 'Default Agent',
  'memberList.realName': 'Member Real Name',
  'memberList.memberAccount': 'Member Account',
  'memberList.memberName': 'Member Nickname',
  'memberList.vipLevels': 'VIP Levels',
  'memberList.validInfos': 'Verification Info',
  'memberList.risks': 'Risk Levels',
  'memberList.manualTags': 'Manual Tags',
  'memberList.manualTagsPlaceholder': 'Please select member tags',
  'memberList.autoTags': 'Auto Tags',
  'memberList.userTags': 'Member Tags',
  'memberList.userTagsPlaceholder': 'Please select a tag',
  'memberList.loginLimit': 'Login Limit',
  'memberList.loginLimitType': 'Login Limit Type',
  'memberList.loginLimitTypePlaceholder': 'Please select login limit type',
  'memberList.loginLimitType.passwordError': 'Login Password Error',
  'memberList.vipLevel': 'Member Level',
  'memberList.registerInfo': 'Registration Info',
  'memberList.registerIp': 'Registration IP',
  'memberList.mainBalance': 'Main Account Balance',
  'memberList.rechargeCount': 'Recharge Count',
  'memberList.withdrawCount': 'Withdraw Count',
  'memberList.totalRecharge': 'Total Recharge',
  'memberList.totalWithdraw': 'Total Withdraw',
  'memberList.validInfo': 'Verification Info',
  'memberList.memberPoints': 'Member Points',
  'memberList.riskLevel': 'Risk Level',
  'memberList.currency': 'Currency',
  'memberList.startDate': 'Start Date',
  'memberList.endDate': 'End Date',
  'memberList.search': 'Search',
  'memberList.reset': 'Reset',
  'memberList.export': 'Export',
  'memberList.export.loading': 'Exporting...',
  'memberList.export.success': 'Export successful',
  'memberList.requestFailed': 'Request failed',
  'memberList.action': 'Action',
  'memberList.view': 'View',
  'memberList.batchSetRisk': 'Batch Set Risk',
  'memberList.noData': 'No data',
  'memberList.upload.selected': 'Clear selected file',
  'memberList.upload.running': 'Uploading',
  'memberList.upload.success': 'Upload successful',
  'memberList.upload.failed': 'Upload failed',
  'memberList.upload.file.size': 'File cannot exceed 2GB',
  'memberList.upload.title': 'Upload member information CSV',
  'memberList.upload.selected.area': 'Click or drag the file to this area to upload',
  'memberList.upload.selected.area.bottom': 'Only CSV files are supported, with a maximum size of 40MB. Field names must meet server requirements. Header columns include: username, date_of_birth, user_type, version, ...; user_type supports NORMAL / STORE, and store users require version: V1 / V2.',
  'memberList.upload.button': 'Upload',

  // Verification info options
  'memberList.validInfo.realName': 'Real Name Verification',
  'memberList.validInfo.mobile': 'Mobile Verification',
  'memberList.validInfo.email': 'Email Verification',
  'memberList.validInfo.kyc': 'KYC Verification',

  // Verification info tags
  'memberList.validInfo.realNameTag': 'Real Name',
  'memberList.validInfo.mobileTag': 'Mobile',
  'memberList.validInfo.emailTag': 'Email',
  'memberList.validInfo.kycTag': 'KYC',
  'memberList.validInfo.verification': ' Verification',

  // Risk level options
  'memberList.riskLevel.limitLogin': 'Login Limit',
  'memberList.riskLevel.limitDeposit': 'Deposit Limit',
  'memberList.riskLevel.limitWithdraw': 'Withdraw Limit',
  'memberList.riskLevel.limitBonus': 'Bonus Limit',
  'memberList.riskLevel.suspiciousRisk': 'Suspicious Risk',
  'memberList.riskLevel.normal': 'Normal',
  'memberList.riskLevel.sameIpRisk': 'Same IP Risk',
  'memberList.riskLevel.sameDeviceRisk': 'Same Device Risk',
  'memberList.riskLevel.sameBankCardRisk': 'Same Bank Card Risk',
  'memberList.riskLevel.sameWalletRisk': 'Same Wallet Risk',

  // Quick date options
  'memberList.quickDate.today': 'Today',
  'memberList.quickDate.yesterday': 'Yesterday',
  'memberList.quickDate.last7Days': 'Last 7 Days',
  'memberList.quickDate.last30Days': 'Last 30 Days',
  'memberList.quickDate.thisWeek': 'This Week',
  'memberList.quickDate.lastWeek': 'Last Week',
  'memberList.quickDate.thisMonth': 'This Month',
  'memberList.quickDate.lastMonth': 'Last Month',

  // Login channel options
  'memberList.loginChannel.label': 'Login Channel',
  'memberList.loginChannel.placeholder': 'Please select login channel',
  'memberList.loginChannel.all': 'All',
  'memberList.loginChannel.others': 'Others',
  'memberList.loginChannel.web': 'Web',
  'memberList.loginChannel.androidApp': 'Android APP',
  'memberList.loginChannel.androidH5': 'Android H5',
  'memberList.loginChannel.androidPwa': 'Android PWA',
  'memberList.loginChannel.iosH5': 'iOS H5',
  'memberList.loginChannel.iosPwa': 'iOS PWA',
  'memberList.loginChannel.iosApp': 'IOS APP',

  // Units
  'memberList.unit.times': ' times',
  'member.detail.modal.addRemark.content': 'Note Content',
  'member.detail.modal.addRemark.placeholder': 'Enter note',
  'member.detail.modal.addRemark.isTop': 'Pin to Top',
  'member.detail.modal.addRemark.success': 'Note added successfully',
  'member.detail.modal.addRemark.error': 'Failed to add note',
  'member.detail.modal.editEmail.title': 'Email',
  'member.detail.modal.editEmail.email': 'Email',
  'member.detail.modal.editEmail.emailPlaceholder': 'Enter email',
  'member.detail.modal.editEmail.emailError': 'Invalid email',
  'member.detail.modal.editEmail.remark': 'Note',
  'member.detail.modal.editEmail.remarkPlaceholder': 'Enter note',
  'member.detail.modal.editEmail.success': 'Email updated successfully',
  'member.detail.modal.editEmail.error': 'Failed to update email',
  'member.detail.modal.editEmail.emailExists': 'Email already exists',
  'member.detail.modal.editIdentity.title': 'Identity Info',
  'member.detail.modal.editIdentity.realName': 'Full Name',
  'member.detail.modal.editIdentity.realNamePlaceholder': 'Enter full name',
  'member.detail.modal.editIdentity.birthdayTime': 'Birth Date',
  'member.detail.modal.editIdentity.remark': 'Note',
  'member.detail.modal.editIdentity.remarkPlaceholder': 'Enter note',
  'member.detail.modal.editIdentity.success': 'Identity updated successfully',
  'member.detail.modal.editIdentity.error': 'Failed to update identity',
  'member.detail.modal.editKyc.title': 'Update KYC',
  'member.detail.modal.editKyc.legalName': 'Legal Name',
  'member.detail.modal.editKyc.legalNamePlaceholder': 'Enter legal name',
  'member.detail.modal.editKyc.birthDate': 'Birth Date',
  'member.detail.modal.editKyc.idCardUrl': 'ID Card',
  'member.detail.modal.editKyc.success': 'KYC updated successfully',
  'member.detail.modal.editKyc.error': 'Failed to update KYC',
  'member.detail.modal.editPhone.title': 'Phone Number',
  'member.detail.modal.editPhone.phoneNumber': 'Phone Number',
  'member.detail.modal.editPhone.phoneNumberPlaceholder': 'Enter phone number',
  'member.detail.modal.editPhone.phoneNumberError': 'Invalid phone number',
  'member.detail.modal.editPhone.remark': 'Note',
  'member.detail.modal.editPhone.remarkPlaceholder': 'Enter note',
  'member.detail.modal.editPhone.success': 'Phone updated successfully',
  'member.detail.modal.editPhone.error': 'Failed to update phone',
  'member.detail.modal.editPhone.phoneExists': 'Phone already exists',
  'member.detail.modal.editRiskLevel.title': 'Risk Level',
  'member.detail.modal.editRiskLevel.riskLevel': 'Risk Level',
  'member.detail.modal.editRiskLevel.riskLevelPlaceholder': 'Select risk level',
  'member.detail.modal.editRiskLevel.remark': 'Note',
  'member.detail.modal.editRiskLevel.remarkPlaceholder': 'Enter note',
  'member.detail.modal.editRiskLevel.success': 'Risk level updated successfully',
  'member.detail.modal.editRiskLevel.error': 'Failed to update risk level',
  'member.detail.modal.editRiskLevel.limitLogin': 'Login Limit',
  'member.detail.modal.editRiskLevel.limitDeposits': 'Deposit Limit',
  'member.detail.modal.editRiskLevel.limitWithdrawal': 'Withdrawal Limit',
  'member.detail.modal.editRiskLevel.limitDiscount': 'Promotion Limit',
  'member.detail.modal.editRiskLevel.potentialRisk': 'Suspicious Risk',
  'member.detail.modal.editRiskLevel.sameIpRisk': 'Same IP Risk',
  'member.detail.modal.editRiskLevel.sameDeviceRisk': 'Same Device Risk',
  'member.detail.modal.editRiskLevel.sameBankCardRisk': 'Same Bank Card Risk',
  'member.detail.modal.editRiskLevel.sameWalletRisk': 'Same Wallet Risk',
  'member.detail.modal.editRiskLevel.loginLimitType': 'Login Limit Type',
  'member.detail.modal.editRiskLevel.loginLimitTypePlaceholder': 'Please select login limit type',
  'member.detail.modal.editRiskLevel.loginLimitTypeRequired': 'Please select login limit type',
  'member.detail.modal.resetPassword.title': 'Reset Password',
  'member.detail.modal.resetPassword.confirmText': 'Confirm reset password?',
  'member.detail.modal.resetPassword.successTitle': 'Password reset successful',
  'member.detail.modal.resetPassword.successText': 'New password:',
  'member.detail.modal.resetPassword.okText': 'Got it',
  'member.detail.modal.resetPassword.error': 'Failed to reset password',
  'member.detail.modal.resetWithdrawPassword.title': 'Reset Withdrawal Password',
  'member.detail.modal.resetWithdrawPassword.confirmText': 'Confirm reset withdrawal password?',
  'member.detail.modal.resetWithdrawPassword.successTitle': 'Password reset successful',
  'member.detail.modal.resetWithdrawPassword.successText': 'New password:',
  'member.detail.modal.resetWithdrawPassword.okText': 'Got it',
  'member.detail.modal.resetWithdrawPassword.error': 'Failed to reset password',
  'member.detail.basicInfo.memberAccount': 'Member Account',
  'member.detail.basicInfo.memberName': 'Member Name',
  'member.detail.basicInfo.agentInviteCode': 'Agent Code',
  'member.detail.basicInfo.isAppUser': 'APP User',
  'member.detail.basicInfo.agentName': 'Direct Agent',
  'member.detail.basicInfo.rootInviter': 'Top Friend',
  'member.detail.basicInfo.sameAsParentInviter': 'Same as upper friend',
  'member.detail.basicInfo.parentInviter': 'Upper Friend',
  'member.detail.basicInfo.inviterCode': 'Friend Invite Code',
  'member.detail.basicInfo.generateInviterCode': 'Generate',
  'member.detail.basicInfo.generateInviterCodeSuccess': 'Friend invite code generated',
  'member.detail.basicInfo.generateInviterCodeFailed': 'Failed to generate friend invite code',
  'member.detail.basicInfo.riskLevel': 'Risk Level',
  'member.detail.basicInfo.registerTime': 'Register Time',
  'member.detail.basicInfo.registerSource': 'Register Source',
  'member.detail.basicInfo.limitLogin': 'Login Limit',
  'member.detail.basicInfo.limitDeposits': 'Deposit Limit',
  'member.detail.basicInfo.limitWithdrawal': 'Withdrawal Limit',
  'member.detail.basicInfo.limitDiscount': 'Promotion Limit',
  'member.detail.userTypeSetting.title': 'User Type Setting',
  'member.detail.userTypeSetting.userType.label': 'User Type',
  'member.detail.userTypeSetting.userType.normal': 'Normal User',
  'member.detail.userTypeSetting.userType.store': 'Retail Store User',
  'member.detail.userTypeSetting.displayVersion.label': 'Display Version',
  'member.detail.userTypeSetting.displayVersion.required': 'Please select display version',
  'member.detail.userTypeSetting.displayVersion.placeholder': 'Please select display version',
  'member.detail.userTypeSetting.displayVersion.hint': 'Version rules are system-defined (see the mapping below); select the version to assign to this user.',
  'member.detail.userTypeSetting.version.v1': 'Version 1 (ecasino)',
  'member.detail.userTypeSetting.version.v2': 'Version 2 (ecasino + ebingo)',
  'member.detail.userTypeSetting.offering.egames': 'E-Games',
  'member.detail.userTypeSetting.offering.ebingo': 'E-Bingo',
  'member.detail.userTypeSetting.offering.sportsbook': 'Sportsbook',
  'member.detail.userTypeSetting.offering.traditional': 'Traditional Bingo',
  'member.detail.userTypeSetting.cat.ebingo': 'bingo (excl. Bingo Pilipino Live)',
  'member.detail.userTypeSetting.cat.traditional': 'Bingo Pilipino Live (OTB)',
  'member.detail.userTypeSetting.excl.sgPoker': 'SG poker',
  'member.detail.userTypeSetting.excl.sgLive': 'SG livecasino',
  'member.detail.userTypeSetting.excl.none': 'No exclusions',
  'member.detail.userTypeSetting.preview.includeTitle': 'Visible / searchable categories',
  'member.detail.userTypeSetting.preview.excludeTitle': 'Exclusions (hidden / not searchable)',
  'member.detail.userTypeSetting.preview.normalNote': 'Normal users access the full online catalog with no version filter; the display version field is hidden.',
  'member.detail.userTypeSetting.mapping.name': 'Display Version',
  'member.detail.userTypeSetting.defaultHint': 'Existing users are treated as normal users by default.',
  'member.detail.userTypeSetting.preview.title': 'Game categories visible and searchable by this user (preview)',
  'member.detail.userTypeSetting.preview.empty': 'Select a display version to preview available categories',
  'member.detail.userTypeSetting.preview.all': 'All Categories',
  'member.detail.userTypeSetting.preview.liveNoSg': 'livecasino (excluding SG)',
  'member.detail.userTypeSetting.preview.pokerNoSg': 'poker (excluding SG)',
  'member.detail.userTypeSetting.preview.bingoNoLive': 'bingo (excluding FBM live bingo)',
  'member.detail.userTypeSetting.annot.effect': 'Takes effect on the next login',
  'member.detail.userTypeSetting.annot.searchCover': 'Search results use the same category filter',
  'member.detail.userTypeSetting.annot.versionFilter': 'Filtered by version on the backend',
  'member.detail.userTypeSetting.mapping.title': 'Version to platform game category mapping (system-defined, reference only)',
  'member.detail.userTypeSetting.mapping.version': 'Version',
  'member.detail.userTypeSetting.mapping.includes': 'Included Categories',
  'member.detail.userTypeSetting.mapping.excludes': 'Exclusions',
  'member.detail.userTypeSetting.mapping.v1Excludes': 'SG poker and livecasino',
  'member.detail.userTypeSetting.mapping.v2Excludes': 'SG poker and livecasino; FBM live bingo',
  'member.detail.userTypeSetting.footer.permNote': 'Entry access is controlled by role permissions',
  'member.detail.userTypeSetting.save': 'Save',
  'member.detail.userTypeSetting.success': 'User type updated successfully',
  'member.detail.userTypeSetting.error': 'Failed to update user type',
  'member.detail.kycInfo.realName': 'Full Name',
  'member.detail.kycInfo.birthDate': 'Birth Date',
  'member.detail.kycInfo.kycStatus': 'KYC Status',
  'member.detail.kycInfo.email': 'Email',
  'member.detail.kycInfo.phoneNumber': 'Phone Number',
  'member.detail.kycInfo.mobileProvider': 'Mobile Provider',
  'member.detail.kycInfo.viewPhone': 'View Phone',
  'member.detail.kycInfo.viewEmail': 'View Email',
  'member.detail.kycInfo.fetchEmailError': 'Failed to get email',
  'member.detail.kycInfo.mobileValid.verified': 'Verified',
  'member.detail.kycInfo.mobileValid.unverified': 'Unverified',
  'member.detail.kycInfo.emailValid.verified': 'Verified',
  'member.detail.kycInfo.emailValid.unverified': 'Unverified',
  'member.detail.kycInfo.simple.pending': 'Register KYC pending review',
  'member.detail.kycInfo.whole.pending': 'Withdraw KYC pending review',
  'member.detail.kycInfo.simple.success': 'Register KYC successful',
  'member.detail.kycInfo.whole.success': 'Withdraw KYC successful',
  'member.detail.kycInfo.simple.failed': 'Register KYC failed',
  'member.detail.kycInfo.whole.failed': 'Withdraw KYC failed',
  'member.detail.kycInfo.simple.blacklist': 'Register KYC blacklist',
  'member.detail.kycInfo.whole.blacklist': 'Withdraw KYC blacklist',
  'member.detail.kycInfo.notSubmitted': 'Not Submitted',
  'member.detail.vipInfo.upgradeGrow': 'VIP Points (Upgrade)',
  'member.detail.vipInfo.retentionGrow': 'VIP Points (Retention)',
  'member.detail.vipInfo.vipLevel': 'VIP Level',
  'member.detail.vipInfo.vipGrow': 'VIP Points',
  'member.detail.vipInfo.noVipInfo': 'No VIP Info',
  'member.detail.vipInfo.fetchError': 'Failed to get VIP info',
  'member.detail.vipInfo.permanentRetention': 'Permanent Retention',
  'member.detail.countryArea.error': 'Failed to get area code',
  'member.detail.memberInfo.error': 'Failed to get member info',
  'member.detail.remarkInfo.noMemberSelected': 'Please select member',
  'member.detail.remarkInfo.remarkContent': 'Note Content',
  'member.detail.remarkInfo.isTop': 'Pin to Top',
  'member.detail.remarkInfo.createTime': 'Create Time',
  'member.detail.remarkInfo.createUser': 'Creator',
  'member.detail.remarkInfo.operation': 'Operation',
  'member.detail.remarkInfo.delete': 'Delete',
  'member.detail.remarkInfo.cancelTop': 'Unpin',
  'member.detail.remarkInfo.setTop': 'Pin',
  'member.detail.remarkInfo.confirmDelete': 'Confirm delete note?',
  'member.detail.remarkInfo.confirm': 'Confirm',
  'member.detail.remarkInfo.cancel': 'Cancel',
  'member.detail.remarkInfo.deleteSuccess': 'Note deleted successfully',
  'member.detail.remarkInfo.deleteError': 'Failed to delete note',
  'member.detail.remarkInfo.topSuccess': 'Pinned successfully',
  'member.detail.remarkInfo.cancelTopSuccess': 'Unpinned successfully',
  'member.detail.remarkInfo.topError': 'Failed to pin',
  'member.detail.remarkInfo.cancelTopError': 'Failed to unpin',
  'member.detail.remarkInfo.yes': 'Yes',
  'member.detail.remarkInfo.no': 'No',
  'member.detail.common.noData': 'No Data',
  'member.detail.common.dash': '-',
  'member.betting.columns.index': 'No.',
  'member.betting.columns.betTime': 'Bet Time',
  'member.betting.columns.betAmount': 'Bet Amount',
  'member.betting.columns.winLossAmount': 'Win/Loss',
  'member.betting.columns.platformCode': 'Platform Name',
  'member.betting.columns.gameType': 'Game Type',
  'member.betting.gameTypes.1': 'Slots',
  'member.betting.gameTypes.2': 'Live',
  'member.betting.gameTypes.3': 'Sports',
  'member.betting.gameTypes.4': 'Lottery',
  'member.betting.gameTypes.5': 'Fishing',
  'member.betting.gameTypes.6': 'Cards',
  'member.betting.gameTypes.7': '3D',
  'member.betting.gameTypes.10': 'Esports',
  'member.betting.gameTypes.12': 'Bingo',
  'member.betting.currentPageTotal': 'Current Page Total',
  'member.welfare.columns.claimTime': 'Claim Time',
  'member.welfare.columns.promotionName': 'Promotion Name',
  'member.welfare.columns.promotionAmount': 'Amount',
  'member.welfare.columns.promotionTemplate': 'Template',
  'member.welfare.columns.sender': 'Sender',
  'member.welfare.columns.status': 'Status',
  'member.welfare.status.0': 'Pending',
  'member.welfare.status.1': 'Completed',
  'member.welfare.status.2': 'Expired',
  'member.trade.columns.transactionTime': 'Transaction Time',
  'member.trade.columns.type': 'Type',
  'member.trade.columns.details': 'Details',
  'member.trade.columns.beforeAmount': 'Before Amount',
  'member.trade.columns.amount': 'Amount',
  'member.trade.columns.afterAmount': 'After Amount',
  'member.trade.columns.operator': 'Operator',
  'member.trade.types.1001': 'Deposit',
  'member.trade.types.1002': 'Withdrawal',
  'member.trade.types.3999': 'Manual Bonus',
  'member.trade.types.3001': 'VIP Upgrade Bonus',
  'member.trade.types.3002': 'VIP Retention Bonus',
  'member.trade.types.3003': 'VIP Weekly Salary',
  'member.trade.types.3004': 'VIP Monthly Salary',
  'member.trade.types.3005': 'VIP Birthday Bonus',
  'member.trade.types.3006': 'VIP Upgrade Points',
  'member.trade.types.3007': 'VIP Retention Points',
  'member.trade.types.3008': 'VIP App Daily Points',
  'member.trade.types.3009': 'VIP H5 Daily Points',
  'member.trade.types.3010': 'VIP Game Rebate Bonus',
  'member.trade.types.3011': 'Rebate Bonus',
  'member.trade.types.3012': 'Registration Bonus',
  'member.trade.types.3013': 'Deposit Bonus',
  'member.trade.types.3014': 'Daily First Deposit Bonus',
  'member.trade.types.3015': 'Login',
  'member.trade.types.3016': 'Recharge',
  'member.trade.types.3017': 'Redemption Code Bonus',
  'member.trade.types.3018': 'Lucky Spin Bonus',
  'member.trade.types.3019': 'Every Recharge Bonus',
  'member.trade.types.3030': 'First Deposit Bonus',
  'member.trade.types.3031': 'Leaderboard Activity Bonus',
  'member.trade.types.3020': 'Invite Reward',
  'member.trade.types.3021': 'Achievement Reward',
  'member.trade.types.3022': 'Invited Reward',
  'member.trade.types.3023': 'Info Binding Bonus',
  'member.trade.types.3024': 'Treasure Box Bonus',
  'member.trade.types.3026': 'Red Packet Rain',
  'member.trade.types.3028': 'Treasure Box Prize',
  'member.trade.types.3029': 'New Rebate Bonus',
  'member.trade.types.3032': 'Invite Deposit Rebate',
  'member.trade.types.3033': 'Invite Bet Rebate',
  'member.trade.types.3034': 'Invite Win/Loss Rebate',
  'member.trade.types.3035': 'Invite NGR Rebate',
  'member.trade.types.5001': 'Manual In',
  'member.trade.types.5002': 'Manual Out',
  'member.trade.types.5003': 'Manual In (No Flow)',
  'member.trade.types.5004': 'Manual Out (No Flow)',
  'member.trade.types.5005': 'Bad Debt Settlement',
  'member.trade.types.5006': 'Agent Deposit',
  'member.trade.types.5007': 'Agent Transfer Out',
  'member.trade.types.6001': 'Game In',
  'member.trade.types.6002': 'Game Out',
  'member.trade.types.7001': 'Point Exchange',
  'member.trade.types.9001': 'Recharge Fuel',
  'member.trade.types.9002': 'Invite Fuel',
  'member.trade.types.9003': 'Entry Reward',
  'member.trade.types.9004': 'Stage Reward',
  'member.trade.types.9005': 'Points Exchange Fuel',
  'member.trade.types.OTHER': 'Other',
  'member.point.columns.changeDate': 'Change Date',
  'member.point.columns.changeType': 'Change Type',
  'member.point.columns.beforePoints': 'Before Points',
  'member.point.columns.changeAmount': 'Change Amount',
  'member.point.columns.afterPoints': 'After Points',
  'member.point.columns.remark': 'Note',
  'member.point.changeTypes.increase': 'Increase',
  'member.point.changeTypes.decrease': 'Decrease',
  'member.point.manualAdjust.title': 'Adjust Points',
  'member.point.manualAdjust.currentPoints': 'Current Points',
  'member.point.manualAdjust.adjustType': 'Adjust Type',
  'member.point.manualAdjust.adjustPoints': 'Adjust Points',
  'member.point.manualAdjust.validDate': 'Expiry Date',
  'member.point.manualAdjust.submitRemark': 'Note',
  'member.point.manualAdjust.increasePoints': 'Increase Points',
  'member.point.manualAdjust.decreasePoints': 'Decrease Points',
  'member.point.manualAdjust.placeholder': 'Enter',
  'member.point.manualAdjust.success': 'Adjustment successful',
  'member.point.manualAdjust.error': 'Adjustment failed',
  'member.point.manualAdjust.getPointsError': 'Failed to get points',
  'wallet.accountBalance.title': 'Account Wallet',
  'wallet.accountBalance.totalBalance': 'Total Balance',
  'wallet.accountBalance.mainBalance': 'Main Account',
  'wallet.accountBalance.memberPoints': 'Member Points',
  'wallet.accountBalance.noPlatformData': 'No Platform Data',
  'wallet.accountBalance.manualAdjust.title': 'Manual Adjustment',
  'wallet.accountBalance.manualAdjust.currency': 'Currency',
  'wallet.accountBalance.manualAdjust.currencyPlaceholder': 'Select currency',
  'wallet.accountBalance.manualAdjust.adjustType': 'Adjust Type',
  'wallet.accountBalance.manualAdjust.adjustTypePlaceholder': 'Select type',
  'wallet.accountBalance.manualAdjust.increaseAmount': 'Increase',
  'wallet.accountBalance.manualAdjust.decreaseAmount': 'Decrease',
  'wallet.accountBalance.manualAdjust.amount': 'Amount',
  'wallet.accountBalance.manualAdjust.amountPlaceholder': 'Enter amount',
  'wallet.accountBalance.manualAdjust.increaseFlow': 'Increase Flow',
  'wallet.accountBalance.manualAdjust.decreaseFlow': 'Decrease Flow',
  'wallet.accountBalance.manualAdjust.flowPlaceholder': 'Enter flow',
  'wallet.accountBalance.manualAdjust.memoPayDeposit': 'Count in Deposit/Withdrawal',
  // —— Refund on deduction ——
  'wallet.accountBalance.manualAdjust.refund.label': 'Quota refund',
  'wallet.accountBalance.manualAdjust.refund.checkbox': 'Refund quota to sources?',
  'wallet.accountBalance.manualAdjust.refund.hint': 'By default the full deduction goes to the platform. Check to manually split refunds back to original sources. Each row ≤ source refundable; sum ≤ deduction; remainder goes to platform.',
  'wallet.accountBalance.manualAdjust.refund.detailTitle': 'Refund detail',
  'wallet.accountBalance.manualAdjust.refund.colSource': 'Source',
  'wallet.accountBalance.manualAdjust.refund.colRefundable': 'Refundable balance',
  'wallet.accountBalance.manualAdjust.refund.colAlreadyRefunded': 'Refunded',
  'wallet.accountBalance.manualAdjust.refund.colRefund': 'Refund amount',
  'wallet.accountBalance.manualAdjust.refund.totalRefund': 'Total refund',
  'wallet.accountBalance.manualAdjust.refund.totalDeduct': 'Total deduction',
  'wallet.accountBalance.manualAdjust.refund.platformResidual': 'Residual (to platform)',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUser': 'Op-user',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUserPlaceholder': 'Backend operator quota',
  'wallet.accountBalance.manualAdjust.refund.sourceL1': 'L1 agent',
  'wallet.accountBalance.manualAdjust.refund.sourceL2': 'L2 agent',
  'wallet.accountBalance.manualAdjust.refund.empty': 'No refundable source for this member/currency',
  'wallet.accountBalance.manualAdjust.refund.errorRowExceed': '⚠ A row exceeds its source refundable balance',
  'wallet.accountBalance.manualAdjust.refund.errorSumExceed': '⚠ Total refund exceeds total deduction',
  'wallet.accountBalance.manualAdjust.refund.fetchFail': 'Failed to load refund sources',
  'wallet.accountBalance.manualAdjust.remark': 'Note',
  'wallet.accountBalance.manualAdjust.remarkPlaceholder': 'Enter note',
  'wallet.accountBalance.manualAdjust.confirm': 'Confirm',
  'wallet.accountBalance.manualAdjust.cancel': 'Cancel',
  'wallet.accountBalance.manualAdjust.success': 'Success',
  'wallet.accountBalance.manualAdjust.error': 'Failed',
  'wallet.bankCards.title': 'Bank Cards',
  'wallet.bankCards.bindTime': 'Bind Time',
  'wallet.bankCards.bankName': 'Bank',
  'wallet.bankCards.cardHolder': 'Card Holder',
  'wallet.bankCards.cardNumber': 'Card Number',
  'wallet.bankCards.status': 'Status',
  'wallet.bankCards.enabled': 'Enabled',
  'wallet.bankCards.disabled': 'Disabled',
  'wallet.bankCards.actions.unbind': 'Unbind',
  'wallet.bankCards.actions.enable': 'Enable',
  'wallet.bankCards.actions.disable': 'Disable',
  'wallet.bankCards.actions.confirmUnbind': 'Confirm Unbind',
  'wallet.bankCards.actions.confirmUnbindContent': 'Confirm unbind card?',
  'wallet.bankCards.actions.confirmEnable': 'Confirm Enable',
  'wallet.bankCards.actions.confirmEnableContent': 'Confirm enable card?',
  'wallet.bankCards.actions.confirmDisable': 'Confirm Disable',
  'wallet.bankCards.actions.confirmDisableContent': 'Confirm disable card?',
  'wallet.bankCards.actions.unbindSuccess': 'Unbind successful',
  'wallet.bankCards.actions.unbindError': 'Unbind failed',
  'wallet.bankCards.actions.enableSuccess': 'Enable successful',
  'wallet.bankCards.actions.enableError': 'Enable failed',
  'wallet.bankCards.actions.disableSuccess': 'Disable successful',
  'wallet.bankCards.actions.disableError': 'Disable failed',
  'wallet.financialOverview.title': 'Financial Overview',
  'wallet.financialOverview.totalDeposit': 'Total Deposit',
  'wallet.financialOverview.totalWithdrawal': 'Total Withdrawal',
  'wallet.financialOverview.firstDeposit': 'First Deposit',
  'wallet.financialOverview.depositCount': 'Deposit Count',
  'wallet.financialOverview.withdrawalCount': 'Withdrawal Count',
  'wallet.financialOverview.totalBonus': 'Total Bonus',
  'wallet.financialOverview.firstDepositTime': 'First Deposit Time',
  'wallet.financialOverview.lastDeposit': 'Last Deposit',
  'wallet.financialOverview.lastDepositTime': 'Last Deposit Time',
  'wallet.financialOverview.historicalProfitLoss': 'Historical Profit/Loss',
  'wallet.financialOverview.historicalProfitLossDesc1': 'Historical Profit/Loss: Statistics of all third-party profit/loss data before yesterday.',
  'wallet.financialOverview.historicalProfitLossDesc2': 'Amount color (consistent with the color logic of the last seven days\' betting).',
  'wallet.financialOverview.historicalProfitLossDesc3': 'Red: Loss, Green: Profit.',
  'wallet.financialOverview.totalBetFlowAmount': 'Total Valid Flow',
  'wallet.financialOverview.pointExchangeAmount': 'Points Exchange Amount',
  'wallet.financialOverview.todayDepositAmount': "Today's Deposit",
  'wallet.financialOverview.todayWithdrawAmount': "Today's Withdrawal",
  'wallet.financialOverview.todayProfitAmount': "Today's Profit",
  'wallet.financialOverview.todayBetAmount': "Today's Bet",
  'wallet.financialOverview.todayBonusAmount': "Today's Bonus (incl. Exchange)",
  'wallet.financialOverview.fetchError': 'Failed to fetch financial overview',
  'wallet.financialOverview.historicalProfitLossFetchError': 'Failed to fetch historical profit/loss',
  'wallet.walletAccounts.title': 'Wallet Info',
  'wallet.walletAccounts.bindTime': 'Bind Time',
  'wallet.walletAccounts.walletType': 'Wallet Type',
  'wallet.walletAccounts.walletName': 'Wallet Name',
  'wallet.walletAccounts.walletAccount': 'Wallet Account',
  'wallet.walletAccounts.usdtType': 'USDT Type',
  'wallet.walletAccounts.status': 'Status',
  'wallet.walletAccounts.enabled': 'Enabled',
  'wallet.walletAccounts.disabled': 'Disabled',
  'wallet.walletAccounts.actions.unbind': 'Unbind',
  'wallet.walletAccounts.actions.enable': 'Enable',
  'wallet.walletAccounts.actions.disable': 'Disable',
  'wallet.walletAccounts.actions.confirmUnbind': 'Confirm Unbind',
  'wallet.walletAccounts.actions.confirmUnbindContent': 'Confirm unbind wallet?',
  'wallet.walletAccounts.actions.confirmEnable': 'Confirm Enable',
  'wallet.walletAccounts.actions.confirmEnableContent': 'Confirm enable wallet?',
  'wallet.walletAccounts.actions.confirmDisable': 'Confirm Disable',
  'wallet.walletAccounts.actions.confirmDisableContent': 'Confirm disable wallet?',
  'wallet.walletAccounts.actions.unbindSuccess': 'Unbind successful',
  'wallet.walletAccounts.actions.unbindError': 'Unbind failed',
  'wallet.walletAccounts.actions.statusUpdateSuccess': 'Status updated',
  'wallet.walletAccounts.actions.statusUpdateError': 'Status update failed',
  'wallet.withdrawalHistory.title': 'Withdrawal History',
  'wallet.withdrawalHistory.remainingFlow': 'Remaining Flow',
  'wallet.withdrawalHistory.completedFlow': 'Completed Flow',
  'wallet.withdrawalHistory.totalFlow': 'Total Flow Required',
  'wallet.withdrawalHistory.manualAdjust.title': 'Flow Adjustment',
  'wallet.withdrawalHistory.manualAdjust.currency': 'Currency',
  'wallet.withdrawalHistory.manualAdjust.currencyPlaceholder': 'Select currency',
  'wallet.withdrawalHistory.manualAdjust.adjustType': 'Adjust Type',
  'wallet.withdrawalHistory.manualAdjust.adjustTypePlaceholder': 'Select type',
  'wallet.withdrawalHistory.manualAdjust.increaseFlow': 'Increase Flow',
  'wallet.withdrawalHistory.manualAdjust.decreaseFlow': 'Decrease Flow',
  'wallet.withdrawalHistory.manualAdjust.amount': 'Amount',
  'wallet.withdrawalHistory.manualAdjust.amountPlaceholder': 'Enter amount',
  'wallet.withdrawalHistory.manualAdjust.remark': 'Note',
  'wallet.withdrawalHistory.manualAdjust.remarkPlaceholder': 'Enter note',
  'wallet.withdrawalHistory.manualAdjust.confirm': 'Confirm',
  'wallet.withdrawalHistory.manualAdjust.cancel': 'Cancel',
  'wallet.withdrawalHistory.manualAdjust.success': 'Success',
  'wallet.withdrawalHistory.manualAdjust.error': 'Failed',
  'wallet.withdrawalHistory.flowChange.title': 'Flow History',
  'wallet.withdrawalHistory.flowChange.operationTime': 'Time',
  'wallet.withdrawalHistory.flowChange.type': 'Type',
  'wallet.withdrawalHistory.flowChange.totalCompletedFlow': 'Total Flow',
  'wallet.withdrawalHistory.flowChange.beforeFlow': 'Before Flow',
  'wallet.withdrawalHistory.flowChange.flowChange': 'Change',
  'wallet.withdrawalHistory.flowChange.afterFlow': 'After Flow',
  'wallet.withdrawalHistory.flowChange.types.recharge': 'Deposit',
  'wallet.withdrawalHistory.flowChange.types.withdraw': 'Withdrawal',
  'wallet.withdrawalHistory.flowChange.types.bonus': 'Bonus',
  'wallet.withdrawalHistory.flowChange.types.rebate': 'Rebate',
  'wallet.withdrawalHistory.flowChange.types.manual': 'Manual',
  'wallet.withdrawalHistory.flowChange.types.game': 'Game',
  'wallet.withdrawalHistory.flowChange.types.point': 'Point',
  'wallet.withdrawalHistory.flowChange.types.unknown': 'Other',
  'wallet.common.refresh': 'Refresh',
  'wallet.common.takeBack': 'Take Back',
  'wallet.common.manualAdjust': 'Manual Adjust',
  'wallet.common.confirm': 'Confirm',
  'wallet.common.cancel': 'Cancel',
  'wallet.common.success': 'Success',
  'wallet.common.error': 'Error',
  'wallet.common.loading': 'Loading...',
  'wallet.common.switchTabToLoad': 'Switch tab to load content',
  'wallet.common.searchMember': 'Please enter member account in search box',
  'wallet.common.operations': 'Operations',
  'wallet.common.takeBackConfirm': 'Are you sure you want to take back to account balance?',
  'wallet.common.takeBackWarning': 'After confirmation, it will be taken back in batch, please check your account balance later.',
  'wallet.withdrawalHistory.flowExceedError': 'Flow adjustment cannot exceed remaining flow',
  'member.gameAccountTrade.columns.transId': 'Transaction ID',
  'member.gameAccountTrade.columns.platformCode': 'Game Platform',
  'member.gameAccountTrade.columns.gameType': 'Game Type',
  'member.gameAccountTrade.columns.gameName': 'Game Name',
  'member.gameAccountTrade.columns.gameCode': 'Game Code',
  'member.gameAccountTrade.columns.eventTime': 'Bet Time',
  'member.gameAccountTrade.columns.createTime': 'Change Time',
  'member.gameAccountTrade.columns.before': 'Before Amount',
  'member.gameAccountTrade.columns.amount': 'Amount',
  'member.gameAccountTrade.columns.balance': 'After Amount',
  'member.gameAccountTrade.columns.action': 'API',
  'member.gameAccountTrade.columns.status': 'Status',
  'member.gameAccountTrade.status.success': 'Success',
  'member.gameAccountTrade.status.refund': 'Refund',
  'member.gameAccountTrade.search.platformPlaceholder': 'All Platforms',
  'member.gameAccountTrade.search.platformAll': 'All Platforms',
  'member.gameAccountTrade.search.last7Days': 'Last 7 Days',
  'member.gameAccountTrade.search.thisMonth': 'This Month',
  'member.gameAccountTrade.gameTypes.1': 'Slot',
  'member.gameAccountTrade.gameTypes.2': 'Live',
  'member.gameAccountTrade.gameTypes.3': 'Sports',
  'member.gameAccountTrade.gameTypes.4': 'Lottery',
  'member.gameAccountTrade.gameTypes.5': 'Fishing',
  'member.gameAccountTrade.gameTypes.6': 'Chess',
  'member.gameAccountTrade.gameTypes.7': '3D',
  'member.gameAccountTrade.search.gameType': 'Game Type',
  'member.gameAccountTrade.search.gamePlatform': 'Game Platform',
  'member.gameAccountTrade.search.accountChangeTime': 'Account Change Time',
  'member.gameAccountTrade.search.betTime': 'Bet Time',
  'member.gameAccountTrade.search.betStartTime': 'Bet Start Time',
  'member.gameAccountTrade.search.betEndTime': 'Bet End Time',
  'member.gameAccountTrade.validation.betTimeExceedError': 'Bet time range cannot exceed account change time range!',
  'member.gameAccountTrade.error.fetchFailed': 'Failed to get game account transactions:',

  // Member No Recharge List Page
  'memberNoRecharge.title': 'Registered No Recharge List',
  'memberNoRecharge.registerTime': 'Registration Time',
  'memberNoRecharge.memberAccount': 'Member Account',
  'memberNoRecharge.memberLevel': 'Member Level',
  'memberNoRecharge.agentAccount': 'Superior Agent Account',
  'memberNoRecharge.registerInfo': 'Registration Info',
  'memberNoRecharge.registerTimeLabel': 'Registration Time',
  'memberNoRecharge.registerIp': 'Registration IP',
  'memberNoRecharge.rechargeCount': 'Recharge Count',
  'memberNoRecharge.withdrawCount': 'Withdraw Count',
  'memberNoRecharge.totalRecharge': 'Total Recharge',
  'memberNoRecharge.totalWithdraw': 'Total Withdraw',
  'memberNoRecharge.firstRechargeTime': 'First Recharge Time',
  'memberNoRecharge.action': 'Action',
  'memberNoRecharge.view': 'View',
  'memberNoRecharge.query': 'Query',
  'memberNoRecharge.reset': 'Reset',
  'memberNoRecharge.export': 'Export',
  'memberNoRecharge.startDate': 'Start Date',
  'memberNoRecharge.endDate': 'End Date',
  'memberNoRecharge.selectTimeRange': 'Please select time range or wait for data loading',
  'memberNoRecharge.exportingData': 'Exporting data...',
  'memberNoRecharge.exportSuccess': 'Export successful',
  'memberNoRecharge.exportFailed': 'Export failed',
  'memberNoRecharge.requestFailed': 'Request failed',
  'memberNoRecharge.selectTimeRangeRequired': 'Please select registration time range',

  // Member Churn List Page Additional Fields
  'memberChurn.accountLabel': 'Account',
  'memberChurn.nameLabel': 'Name',
  'memberChurn.nicknameLabel': 'Nickname',
  'memberChurn.registerTimeLabel': 'Registration Time',
  'memberChurn.registerIpLabel': 'Registration IP',
  'memberChurn.lastRechargeTimeLabel': 'Last Recharge Time',
  'memberChurn.caliberExplanation.title': 'Churn Caliber Description',
  'memberChurn.caliberExplanation.rule1': 'Filter Instructions (Last Behavior Time)',
  'memberChurn.caliberExplanation.rule2': '• Can filter individually or in combination: Last Recharge / Last Login / Last Betting (all are user "last" behavior time).',
  'memberChurn.caliberExplanation.rule3': '• Time Usage:',
  'memberChurn.caliberExplanation.rule4': '– Fill only "End" ⇒ Find last time ≤ that date;',
  'memberChurn.caliberExplanation.rule5': '– Fill only "Start" ⇒ Find last time ≥ that date (still active recently);',
  'memberChurn.caliberExplanation.rule6': '– Fill "Start+End" ⇒ Find last time within that range.',
  'memberChurn.caliberExplanation.rule7': 'Single Caliber Examples',
  'memberChurn.caliberExplanation.example1': '– Today 9/27, recharge end=9/24 ⇒ Users with last recharge ≤ 9/24;',
  'memberChurn.caliberExplanation.example2': '– Login range 8/1–8/7 ⇒ Users with last login between 8/1–8/7;',
  'memberChurn.caliberExplanation.example3': '– Betting only start=9/01 ⇒ Users with last betting ≥ 9/01.',
  'memberChurn.caliberExplanation.rule8': 'Combination Usage (Answer Different Business Questions)',
  'memberChurn.caliberExplanation.example4': '– Recharge AND Login: Did they return after recharge? (e.g., lastDep in Aug, lastLogin in Sep?)',
  'memberChurn.caliberExplanation.example5': '– Recharge AND Betting: Did they actually consume after recharge? (e.g., lastDep new, but lastBet old → deposit but not play)',
  'memberChurn.caliberExplanation.example6': '– Login AND Betting: Do they bet when they return? (e.g., lastLogin new, lastBet old → good visit retention, poor consumption retention)',
  'memberChurn.caliberExplanation.example7': '– Recharge AND Login AND Betting: All new = high-value active users; any old = targeted recall.',
  'memberChurn.lastLoginStartTime': 'Last Login Time (Start)',
  'memberChurn.lastLoginEndTime': 'Last Login Time (End)',
  'memberChurn.lastBettingStartTime': 'Last Betting Time (Start)',
  'memberChurn.lastBettingEndTime': 'Last Betting Time (End)',
  'member.gameAccountTrade.validation.dateRangeExceedError': 'Account change time range cannot exceed 7 days!',

  // KycRecordAdd.tsx
  'member.detail.modal.addKyc.title': 'update KYC',
  'kyc.add.form.basic.information': 'Basic Information',
  'kyc.add.form.fullName': 'Full Name',
  'kyc.add.form.firstName': 'firstName',
  'kyc.add.form.middleName': 'middleName',
  'kyc.add.form.lastName': 'lastName',
  'kyc.add.form.birth.date': 'Date of Birth',
  'kyc.add.form.upload.id': 'Upload your ID',
  'kyc.add.form.upload.selfie': 'Selfie with your submitted ID',
  'kyc.add.form.additional.information': 'Additional Information',
  'kyc.add.form.birth.place': 'Place of Birth',
  'kyc.add.form.permanent.address': 'Permanent Address',
  'kyc.add.form.current.address': 'Present Address',
  'kyc.add.form.nationality': 'Nationality',
  'kyc.add.form.income.source': 'Source of Income',
  'kyc.add.form.work.nature': 'Nature of Work',
  'kyc.add.form.upload.latest': 'Latest Photo',

  // Silent Users List
  'memberSilent.title': 'Silent Users List',
  'memberSilent.noDepositDate': 'No Deposit Date',
  'memberSilent.noDepositDateTip': 'Last deposit earlier than this date or empty is considered as "silent user"',
  'memberSilent.noDepositDateDescription': '"No Deposit Date" represents the benchmark date; "Silent" = last deposit earlier than this date or empty. When "Today Enter Silent" is checked: if historical date is selected, "today" refers to that date; to match SMS tasks, please select "Last N days (up to today)".',
  'memberSilent.selectDate': 'Select Date',
  'memberSilent.selectNoDepositDate': 'Please select no deposit date',
  'memberSilent.selectNoDepositDateRequired': 'No deposit date is required',
  'memberSilent.isTodayEnterSilent': 'Today Enter Silent',
  'memberSilent.isTodayEnterSilentTip': 'Check to only see "today enter silent" users; if historical date is selected, "today" = that date',
  'memberSilent.requireLogin': 'Require Login in Period',
  'memberSilent.loginStart': 'Login Start Time',
  'memberSilent.loginEnd': 'Login End Time',
  'memberSilent.requireBetting': 'Require Betting in Period',
  'memberSilent.bettingStart': 'Betting Start Time',
  'memberSilent.bettingEnd': 'Betting End Time',
  'memberSilent.vipLevels': 'VIP Levels',
  'memberSilent.selectVipLevels': 'Please select VIP levels',
  'memberSilent.selectAllVip': 'Select All',
  'memberSilent.excludeOfficialUsers': 'Exclude Official Users',
  'memberSilent.excludeAllAgents': 'Exclude All Agents',
  'memberSilent.excludeAgentIds': 'Exclude Specific Agents',
  'memberSilent.selectExcludeAgents': 'Select agents to exclude (searchable, multiple)',
  'memberSilent.query': 'Query',
  'memberSilent.reset': 'Reset',
  'memberSilent.export': 'Export',
  'memberSilent.exportingData': 'Exporting data...',
  'memberSilent.exportSuccess': 'Export successful',
  'memberSilent.exportFailed': 'Export failed',
  'memberSilent.requestFailed': 'Request failed',
  'memberSilent.lastLoginTime': 'Last Login Time',
  'memberSilent.currencyRequired': 'Please select currency',
  'memberSilent.lastRechargeTime': 'Last Recharge Time',
  'memberSilent.lastBettingTime': 'Last Betting Time',
  'memberSilent.totalRecharge': 'Total Recharge (Multi-currency)',
  'memberSilent.tip': 'Tip',
  // Risk Control Information
  'member.detail.riskControl.sameIpUsers': 'Same IP Users',
  'member.detail.riskControl.sameDeviceUsers': 'Same Device Users',
  'member.detail.riskControl.sameBankCardUsers': 'Same Bank Card Users',
  'member.detail.riskControl.sameWalletUsers': 'Same Wallet Users',
  'member.detail.riskControl.ipAddress': 'IP Address',
  'member.detail.riskControl.ipRegion': 'IP Region',
  'member.detail.riskControl.deviceId': 'Device ID',
  'member.detail.riskControl.deviceType': 'Device Type',
  'member.detail.riskControl.bankAccountName': 'Bank Account Name',
  'member.detail.riskControl.bankCardNumber': 'Bank Card Number',
  'member.detail.riskControl.walletAccount': 'Wallet Account',
  'member.detail.riskControl.walletType': 'Wallet Type',
  'member.detail.riskControl.associatedAccounts': 'Associated Accounts',
  'member.detail.riskControl.expand': 'Expand',
  'member.detail.riskControl.allAccounts': 'All Associated Accounts',
  'member.detail.riskControl.totalAccounts': 'Total Accounts',
  'member.detail.riskControl.searchAccount': 'Search Account',
  'member.detail.riskControl.noAccountsFound': 'No accounts found',

  // Invite Friends List
  'inviterList.title': 'Invite Friends List',
  'inviterList.column.chainTime': 'Chain Start Time',
  'inviterList.column.lastInviteTime': 'Last Invite Time',
  'inviterList.column.lineCount': 'Whole Line Members',
  'inviterList.column.belongAgent': 'Belong Agent',
  'inviterList.agentUnassigned': 'Unassigned',
  'inviterList.editAgent': 'Edit',
  'inviterList.agentFilterPlaceholder': 'All (searchable)',
  'inviterList.topInviter': 'Top',
  'inviterList.depth.level': 'Level {{level}} Friend',
  'inviterList.status.valid': 'Valid',
  'inviterList.status.notQualified': 'Not Qualified',
  'inviterList.tag.inviteeBlocked': 'Invitee Blocked',
  'inviterList.tag.inviterBlocked': 'Inviter Blocked',
  'inviterList.action.drill': 'View Downline',
  'inviterList.action.report': 'Report',
  'inviterList.filter.account': 'Account',
  'inviterList.filter.accountPlaceholder': 'Enter member account',
  'inviterList.filter.tag': 'Member Tag',
  'inviterList.filter.currency': 'Currency',
  'inviterList.filter.tagPlaceholder': 'e.g. Promoter',
  'inviterList.inviter': 'Inviter',
  'inviterList.inviterPlaceholder': 'Please enter inviter account or UID',
  'inviterList.inviteCode': 'Invite Code',
  'inviterList.inviteCodePlaceholder': 'Please enter invite code',
  'inviterList.inviteStatus': 'Invite Status',
  'inviterList.status.all': 'All',
  'inviterList.status.normal': 'Normal',
  'inviterList.status.blacklist': 'Blacklist',
  'inviterList.search': 'Search',
  'inviterList.reset': 'Reset',
  'inviterList.export': 'Export',
  'inviterList.exporting': 'Exporting, please wait...',
  'inviterList.exportSuccess': 'Export successful',
  'inviterList.exportFailed': 'Export failed',
  'inviterList.inviteSettings': 'Invite Settings',
  'inviterList.searchHint': 'Please fill in at least one of inviter or invite code.',
  'inviterList.registerTime': 'Register Time',
  'inviterList.inviteCount': 'Invite Count',
  'inviterList.validCount': 'Valid Count',
  'inviterList.depositUsers': 'Deposit Users',
  'inviterList.metric.inviteCount': 'Invite Count',
  'inviterList.metric.validCount': 'Valid Count',
  'inviterList.metric.depositCount': 'Deposit Users',
  'inviterList.metricValue': 'Value',
  'inviterList.action': 'Action',
  'inviterList.detail': 'Detail',
  'inviterList.addBlacklist': 'Add to Blacklist',
  'inviterList.removeBlacklist': 'Remove from Blacklist',
  'inviterList.total': 'Total {count} inviters.',
  'inviterList.uid': 'UID',
  'inviterList.requestFailed': 'Request failed',
  'inviterList.setting': 'Setting',
  'inviterList.delete': 'Delete',
  'inviterList.currentStatus': 'Current Status',
  'inviterList.currencySwitchHint': 'Currency switching will affect statistics and list data.',

  // Invitee
  'inviterList.invitee.title': 'Invitee Users',
  'inviterList.invitee.account': 'Member Account',
  'inviterList.invitee.memberId': 'Member Account',
  'inviterList.invitee.memberIdPlaceholder': 'Please enter member account (Member ID)',
  'inviterList.invitee.status': 'Invitee Status',
  'inviterList.invitee.level': 'Tier',
  'inviterList.invitee.level.1': 'Tier 1 Friend',
  'inviterList.invitee.level.2': 'Tier 2 Friend',
  'inviterList.invitee.level.3': 'Tier 3 Friend',
  'inviterList.invitee.level.n': 'Level {{level}} friend',
  'inviterList.inviteeStatus.valid': 'Valid',
  'inviterList.inviteeStatus.invalid': 'Invalid',
  'inviterList.inviteeStatus.blacklist': 'Blacklisted',
  'inviterList.invitee.registerTime': 'Register Time',
  'inviterList.invitee.effectiveTime': 'Effective Time',
  'inviterList.invitee.firstDepositAmount': 'First Deposit Amount',
  'inviterList.invitee.firstDepositTime': 'First Deposit Time',
  'inviterList.invitee.totalDeposit': 'Valid Amount',
  'inviterList.invitee.totalFlow': 'Valid Flow',
  'inviterList.invitee.currentStatus': 'Current Status',
  'inviterList.invitee.timeMode': 'Time Selection',
  'inviterList.invitee.timeMode.none': 'None',
  'inviterList.invitee.timeMode.register': 'Register Time',
  'inviterList.invitee.timeMode.effective': 'Effective Time',
  'inviterList.invitee.startDate': 'Start Date',
  'inviterList.invitee.endDate': 'End Date',
  'inviterList.invitee.stats.depositUsers': 'Valid Users',
  'inviterList.invitee.stats.totalDeposit': 'Total Deposit',
  'inviterList.invitee.stats.totalFlow': 'Valid Flow',
  'inviterList.invitee.total': 'Total {count} invitee users ({currency}).',
  'inviterList.invitee.loadMore': 'Show more ({{loaded}} / {{total}} loaded)',

  // Invitee Setting
  'inviterList.inviteeSetting.title': 'Invitee Setting',
  'inviterList.inviteeSetting.warning': 'This operation will affect invite relationship and reward distribution. Please confirm before executing.',
  'inviterList.inviteeSetting.actionType': 'Available Actions',
  'inviterList.inviteeSetting.setValid': 'Remove from Blacklist',
  'inviterList.inviteeSetting.setInvalid': 'Set as Blacklist',
  'inviterList.inviteeSetting.actionHint': 'Set as Valid: Only validate deposit threshold and time limit. Set as Invalid: Take effect immediately and clear effective time.',
  'inviterList.inviteeSetting.reason': 'Operation Reason',
  'inviterList.inviteeSetting.reasonPlaceholder': 'Please enter operation reason (required)',
  'inviterList.inviteeSetting.reasonRequired': 'Operation reason is required',
  'inviterList.inviteeSetting.history.title': 'History',
  'inviterList.inviteeSetting.history.time': 'Time',
  'inviterList.inviteeSetting.history.action': 'Action',
  'inviterList.inviteeSetting.history.operator': 'Operator',
  'inviterList.inviteeSetting.history.reason': 'Reason',
  'inviterList.inviteeSetting.history.add': 'Add Risk Control',
  'inviterList.inviteeSetting.history.remove': 'Remove Risk Control',
  'inviterList.inviteeSetting.success': 'Operation successful',
  'inviterList.inviteeSetting.failed': 'Operation failed',

  // Blacklist
  'inviterList.blacklist.addTitle': 'Add to Invite Blacklist',
  'inviterList.blacklist.removeTitle': 'Remove from Invite Blacklist',
  'inviterList.blacklist.warning': 'This operation will affect invite relationship and reward distribution. Please confirm before executing.',
  'inviterList.blacklist.reason': 'Operation Reason',
  'inviterList.blacklist.reasonPlaceholder': 'Please enter operation reason (required)',
  'inviterList.blacklist.reasonRequired': 'Operation reason is required',
  'inviterList.blacklist.history.title': 'History',
  'inviterList.blacklist.history.time': 'Time',
  'inviterList.blacklist.history.action': 'Action',
  'inviterList.blacklist.history.operator': 'Operator',
  'inviterList.blacklist.history.reason': 'Reason',
  'inviterList.blacklist.history.add': 'Add Risk Control',
  'inviterList.blacklist.history.remove': 'Remove Risk Control',
  'inviterList.blacklist.addSuccess': 'Added to blacklist',
  'inviterList.blacklist.removeSuccess': 'Removed from blacklist',
  'inviterList.blacklist.failed': 'Operation failed',

  // Invite Settings
  'inviterList.inviteSettings.title': 'Invite Settings',
  'inviterList.inviteSettings.systemStatus': 'System Function Status',
  'inviterList.inviteSettings.systemStatusHint': 'Only controlled by backend, not displayed to users.',
  'inviterList.inviteSettings.enabled': 'Enabled',
  'inviterList.inviteSettings.disabled': 'Disabled',
  'inviterList.inviteSettings.effectiveTime': 'Effective Time',
  'inviterList.inviteSettings.longTerm': 'Long Term',
  'inviterList.inviteSettings.timeRange': 'Specified Time Range',
  'inviterList.inviteSettings.shareDomain': 'Frontend Share Link Main Domain',
  'inviterList.inviteSettings.currencyConfigs': 'Currency Configurations (Multiple)',
  'inviterList.inviteSettings.currencyConfigsHint': 'Each currency has its own "Valid User Definition" (cannot share if amounts differ).',
  'inviterList.inviteSettings.addCurrencyConfig': 'Add Currency Configuration',
  'inviterList.inviteSettings.currency': 'Currency',
  'inviterList.inviteSettings.relatedPromo': 'Related Promotion',
  'inviterList.inviteSettings.selectPromo': 'Select Promotion Name',
  'inviterList.inviteSettings.defaultPromo': 'Invite Friends (Default)',
  'inviterList.inviteSettings.depositThreshold': 'Cumulative Deposit Threshold',
  'inviterList.inviteSettings.depositFlowThreshold': 'Cumulative Valid Flow Threshold',
  'inviterList.inviteSettings.amount': 'Amount',
  'inviterList.inviteSettings.timeLimit': 'Time Limit for Qualification',
  'inviterList.inviteSettings.timeLimit.afterRegister': 'After Registration',
  'inviterList.inviteSettings.timeLimit.inActive': 'Complete within Active Period',
  'inviterList.inviteSettings.days': 'Days',
  'inviterList.inviteSettings.tip': 'Tip',
  'inviterList.inviteSettings.tipContent': '"Set as Valid" only validates: deposit threshold and time limit (N days after registration / complete within active period).',
  'inviterList.inviteSettings.saveSuccess': 'Save successful',
  'inviterList.inviteSettings.saveFailed': 'Save failed',
  'inviterList.inviteSettings.duplicateCurrency': 'Currency {currencies} has duplicate configurations. Only one configuration per currency is allowed',
  'inviterList.inviteSettings.currencyExists': 'Currency {currency} already has a configuration. Only one configuration per currency is allowed',

  // Bad Debt Records
  'member.badDebt.columns.badDebtTime': 'Bad Debt Time',
  'member.badDebt.columns.betOrderNo': 'Bet Order No',
  'member.badDebt.columns.externalBetOrderNo': 'Order No',
  'member.badDebt.columns.gamePlatform': 'Game Platform',
  'member.badDebt.columns.gameType': 'Game Type',
  'member.badDebt.columns.betTime': 'Bet Time',
  'member.badDebt.columns.settleTime': 'Settle Time',
  'member.badDebt.columns.betAmount': 'Bet Amount',
  'member.badDebt.columns.payoutAmount': 'Payout Amount',
  'member.badDebt.columns.badDebtAmount': 'Bad Debt Amount (Receivable)',
  'member.badDebt.columns.deductedAmount': 'Deducted Amount (Received)',
  'member.badDebt.columns.undeductedAmount': 'Undeducted Amount (Unreceived)',
  'member.badDebt.columns.badDebtStatus': 'Bad Debt Status',
  'member.badDebt.columns.lastDeductionTime': 'Last Deduction Time',
  'member.badDebt.columns.operation': 'Operation',
  'member.badDebt.search.badDebtTime': 'Bad Debt Time',
  'member.badDebt.search.badDebtStatus': 'Bad Debt Status',
  'member.badDebt.search.gamePlatform': 'Game Platform',
  'member.badDebt.search.gameType': 'Game Type',
  'member.badDebt.search.betOrderNo': 'Bet Order No',
  'member.badDebt.search.externalBetOrderNo': 'Order No',
  'member.badDebt.search.externalBetOrderNoPlaceholder': 'Please enter order number',
  'member.badDebt.search.selectBadDebtStatus': 'Select Bad Debt Status',
  'member.badDebt.search.selectGamePlatform': 'All',
  'member.badDebt.search.selectGameType': 'All',
  'member.badDebt.search.betOrderNoPlaceholder': 'Please enter',
  'member.badDebt.search.query': 'Query',
  'member.badDebt.search.refresh': 'Refresh',
  'member.badDebt.search.export': 'Export',
  'member.badDebt.status.pending': 'Pending Deduction',
  'member.badDebt.status.partial': 'Partially Deducted',
  'member.badDebt.status.settled': 'Settled',
  'member.badDebt.status.writtenOff': 'Written Off',
  'member.badDebt.operation.viewDetail': 'View Detail',
  'member.badDebt.detail.title': 'Bad Debt Details',
  'member.badDebt.detail.basicInfo': 'Basic Information',
  'member.badDebt.detail.memberAccount': 'Member Account',
  'member.badDebt.detail.platformName': 'Platform Name',
  'member.badDebt.detail.currency': 'Currency',
  'member.badDebt.detail.gameName': 'Game Name',
  'member.badDebt.detail.deductionHistory': 'Deduction History',
  'member.badDebt.detail.deductionTime': 'Deduction Time',
  'member.badDebt.detail.badDebtAmount': 'Bad Debt Amount',
  'member.badDebt.detail.deductAmount': 'Deduct Amount',
  'member.badDebt.detail.badDebtStatus': 'Bad Debt Status',
  'member.badDebt.detail.remark': 'Remark',
  'member.badDebt.writeOff.button': 'Write Off',
  'member.badDebt.writeOff.confirmTitle': 'Confirm Write Off',
  'member.badDebt.writeOff.confirmContent': 'Are you sure you want to write off? This operation cannot be undone.',
  'member.badDebt.writeOff.defaultRemark': 'Manual Write Off',
  'member.badDebt.message.viewDetailComingSoon': 'View detail feature coming soon',
  'member.badDebt.message.dataPkCodeRequired': 'Data PK Code does not exist',
  'member.badDebt.message.fetchDetailFailed': 'Failed to fetch details',
  'member.badDebt.message.writeOffSuccess': 'Write off successful',
  'member.badDebt.message.writeOffFailed': 'Write off failed',
  'member.badDebt.error.fetchFailed': 'Failed to fetch bad debt data',
  'member.badDebt.message.selectMember': 'Please select a member first',
  'member.badDebt.message.exporting': 'Exporting...',
  'member.badDebt.message.exportSuccess': 'Export successful',
  'member.badDebt.message.exportFailed': 'Export failed',
  // Common translations for bad debt detail modal
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'common.noData': 'No Data',

  // Deposit Member List Page
  'depositMemberList.title': 'Deposit Member List',
  'depositMemberList.subtitle': '(Besides time filter, please fill in at least one query condition)',
  'depositMemberList.searchWarning': 'Please fill in at least one query condition',
  'depositMemberList.timeRequired': 'Please select time range',
  'depositMemberList.currencyRequiredForRecharge': 'Please select currency when filtering by deposit count or amount',
  'depositMemberList.currencyRequiredForTimeType': 'Please select currency when filtering by first deposit time or last deposit time',
  'depositMemberList.timeType': 'Time Type',
  'depositMemberList.lastRechargeTime': 'Last Deposit Time',
  'depositMemberList.firstRechargeTime': 'First Deposit Time',
  'depositMemberList.registerTime': 'Register Time',
  'depositMemberList.memberAccount': 'Member Account',
  'depositMemberList.memberAccountLabel': 'Member Account',
  'depositMemberList.memberAccountPlaceholder': 'Please enter member account',
  'depositMemberList.realName': 'Real Name',
  'depositMemberList.realNameLabel': 'Real Name',
  'depositMemberList.realNamePlaceholder': 'Please enter real name',
  'depositMemberList.memberNameLabel': 'Member Name',
  'depositMemberList.agentAccount': 'Agent Account',
  'depositMemberList.agentAccountPlaceholder': 'Please enter agent account',
  'depositMemberList.rechargeCount': 'Deposit Count',
  'depositMemberList.rechargeCountPlaceholder': 'Please enter min deposit count',
  'depositMemberList.rechargeAmount': 'Deposit Amount',
  'depositMemberList.rechargeAmountPlaceholder': 'Please enter min deposit amount',
  'depositMemberList.excludeAgent': 'Exclude Agent',
  'depositMemberList.excludeAgentPlaceholder': 'Select agents to exclude (searchable, multi-select)',
  'depositMemberList.excludeAllAgent': 'Exclude All Agents',
  'depositMemberList.excludeOfficialUser': 'Exclude Official Users',
  'depositMemberList.mobileValid': 'Mobile Verified Users',
  'depositMemberList.smsTask': 'Related SMS Task',
  'depositMemberList.smsTaskPlaceholder': 'Select SMS task to filter',
  'depositMemberList.matchedUsers': 'matched users',
  'depositMemberList.search': 'Search',
  'depositMemberList.reset': 'Reset',
  'depositMemberList.export': 'Export',
  'depositMemberList.vipLevel': 'VIP Level',
  'depositMemberList.registerInfo': 'Registration Info',
  'depositMemberList.registerIp': 'Register IP',
  'depositMemberList.depositCount': 'Deposit Count',
  'depositMemberList.firstDepositAmount': 'First Deposit Amount',
  'depositMemberList.firstDepositTime': 'First Deposit Time',
  'depositMemberList.lastDepositAmount': 'Last Deposit Amount',
  'depositMemberList.lastDepositTime': 'Last Deposit Time',
  'depositMemberList.totalDeposit': 'Total Deposit',
  'depositMemberList.totalWithdraw': 'Total Withdraw',
  'depositMemberList.depositWithdrawDiff': 'Deposit-Withdraw Diff',
  'depositMemberList.action': 'Action',
  'depositMemberList.view': 'Details',
  // Pay Order History Modal
  'depositMemberList.payOrderHistory.title': 'Pay Order History',
  'depositMemberList.payOrderHistory.fetchError': 'Failed to fetch pay order history',
  'depositMemberList.payOrderHistory.orderNumber': 'Order Number',
  'depositMemberList.payOrderHistory.amount': 'Amount',
  'depositMemberList.payOrderHistory.paymentMethod': 'Payment Method',
  'depositMemberList.payOrderHistory.paymentChannel': 'Payment Channel',
  'depositMemberList.payOrderHistory.createTime': 'Create Time',
  'depositMemberList.payOrderHistory.successTime': 'Success Time',
  'depositMemberList.payOrderHistory.status': 'Status',
  'depositMemberList.payOrderHistory.status.pending': 'Pending',
  'depositMemberList.payOrderHistory.status.paid': 'Paid',
  'depositMemberList.payOrderHistory.status.expired': 'Expired',
  'depositMemberList.payOrderHistory.status.invalid': 'Invalid',

  // VIP Member List page
  'vipMemberList.title': 'VIP Member List',
  'vipMemberList.timeRequired': 'Please select time range',
  'vipMemberList.currencyRequiredForRecharge': 'Please select currency when filtering by deposit count, amount or withdrawal count',
  'vipMemberList.currencyRequiredForTimeType': 'Please select currency when filtering by last deposit time',
  'vipMemberList.timeType': 'Time Type',
  'vipMemberList.lastRechargeTime': 'Last Deposit Time',
  'vipMemberList.firstRechargeTime': 'First Deposit Time',
  'vipMemberList.registerTime': 'Register Time',
  'vipMemberList.memberAccount': 'Member Account',
  'vipMemberList.memberAccountLabel': 'Account',
  'vipMemberList.memberAccountPlaceholder': 'Please enter member account',
  'vipMemberList.realName': 'Real Name',
  'vipMemberList.realNameLabel': 'Real Name',
  'vipMemberList.realNamePlaceholder': 'Please enter real name',
  'vipMemberList.memberNameLabel': 'Nickname',
  'vipMemberList.agentAccount': 'Agent Account',
  'vipMemberList.agentAccountPlaceholder': 'Please enter agent account',
  'vipMemberList.rechargeCount': 'Deposit Count',
  'vipMemberList.rechargeCountPlaceholder': 'Please enter min deposit count',
  'vipMemberList.rechargeAmount': 'Deposit Amount',
  'vipMemberList.rechargeAmountPlaceholder': 'Please enter min deposit amount',
  'vipMemberList.withdrawCountPlaceholder': 'Please enter min withdraw count',
  'vipMemberList.excludeAgent': 'Exclude Agents',
  'vipMemberList.excludeAgentPlaceholder': 'Select agents to exclude',
  'vipMemberList.excludeAllAgent': 'Exclude All Agents',
  'vipMemberList.excludeOfficialUser': 'Exclude Official Users',
  'vipMemberList.smsTask': 'SMS Task',
  'vipMemberList.smsTaskPlaceholder': 'Select SMS task to filter',
  'vipMemberList.search': 'Search',
  'vipMemberList.reset': 'Reset',
  'vipMemberList.export': 'Export',
  'vipMemberList.vipLevel': 'VIP Level',
  'vipMemberList.registerInfo': 'Register Info',
  'vipMemberList.registerIp': 'Register IP',
  'vipMemberList.lastDepositTime': 'Last Deposit Time',
  'vipMemberList.totalDeposit': 'Total Deposit',
  'vipMemberList.totalWithdraw': 'Total Withdraw',
  'vipMemberList.depositWithdrawDiff': 'Deposit-Withdraw Diff',
  'vipMemberList.totalBetAmount': 'Total Bet',
  'vipMemberList.totalWinLoss': 'Total Win/Loss',
  'vipMemberList.lastBetTime': 'Last Bet Time',
  'vipMemberList.lastLoginTime': 'Last Login Time',
  'vipMemberList.vipLevelTime': 'VIP Level Change Time',
  'vipMemberList.action': 'Action',
  'vipMemberList.view': 'Details',

  // Jeepney Fission User Query
  'jeepneyUserList.title': 'Fission User Query',
  'jeepneyUserList.timeType': 'Time Type',
  'jeepneyUserList.lastLoginTime': 'Last Login Time',
  'jeepneyUserList.lastAdvanceTime': 'Last Advance Time',
  'jeepneyUserList.memberAccount': 'Member Account',
  'jeepneyUserList.memberAccountPlaceholder': 'Enter member account',
  'jeepneyUserList.accountLabel': 'Account',
  'jeepneyUserList.memberAccountLabel': 'Member Account',
  'jeepneyUserList.memberRealNameLabel': 'Real Name',
  'jeepneyUserList.memberNicknameLabel': 'Nickname',
  'jeepneyUserList.realName': 'Real Name',
  'jeepneyUserList.realNamePlaceholder': '',
  'jeepneyUserList.realNameLabel': 'Name',
  'jeepneyUserList.nicknameLabel': 'Nickname',
  'jeepneyUserList.vipLevel': 'VIP Level',
  'jeepneyUserList.memberLevel': 'Member Level',
  'jeepneyUserList.currentRound': 'Current Round',
  'jeepneyUserList.currentStage': 'Current Stage',
  'jeepneyUserList.rechargeCount': 'Recharge Count',
  'jeepneyUserList.rechargeAmount': 'Recharge Amount',
  'jeepneyUserList.settlementSuccessCount': 'Settlement Success',
  'jeepneyUserList.settlementFailureCount': 'Settlement Failure',
  'jeepneyUserList.inviteCount': 'Invite Count',
  'jeepneyUserList.validInviteCount': 'Valid Invite Count',
  'jeepneyUserList.pointsExchangeCount': 'Points Exchange Count',
  'jeepneyUserList.currency': 'Currency',
  'jeepneyUserList.currencyAll': 'All',
  'jeepneyUserList.distributedAmount': 'Distributed Amount',
  'jeepneyUserList.fuelCurrency': 'Fuel Currency',
  'jeepneyUserList.fuelCurrencyTitle': 'Fuel Currency Details',
  'jeepneyUserList.viewDetail': 'View Details',
  'jeepneyUserList.fuelBalance': 'Fuel Balance',
  'jeepneyUserList.fuelEarned': 'Fuel Earned',
  'jeepneyUserList.fuelConsumed': 'Fuel Consumed',
  'jeepneyUserList.fuelConsumedShort': 'Consume',
  'jeepneyUserList.fuelEarnedShort': 'Earn',
  'jeepneyUserList.fuelBalanceShort': 'Balance',
  'jeepneyUserList.fuelItem': 'Item',
  'jeepneyUserList.fuelValue': 'Value',
  'jeepneyUserList.fuelDate': 'Date',
  'jeepneyUserList.fuelMemberAccount': 'Member Account',
  'jeepneyUserList.fuelTransactionType': 'Type',
  'jeepneyUserList.fuelSourceType': 'Source',
  'jeepneyUserList.fuelSourceTypeLabel': 'Reward Source',
  'jeepneyUserList.fuelTransactionTypeLabel': 'Currency Type',
  'jeepneyUserList.fuelAmount': 'Amount',
  'jeepneyUserList.fuelBalanceBefore': 'Before',
  'jeepneyUserList.fuelBalanceAfter': 'After',
  'jeepneyUserList.sourceTypeAll': 'All',
  'jeepneyUserList.sourceTypeStageConsume': 'Stage Consumption',
  'jeepneyUserList.sourceTypeRoundClear': 'Round End Clearance',
  'jeepneyUserList.sourceTypeRecharge': 'Recharge Fuel',
  'jeepneyUserList.sourceTypeInvite': 'Invite Fuel',
  'jeepneyUserList.sourceTypeEntry': 'Entry Reward',
  'jeepneyUserList.sourceTypeStage': 'Stage Reward',
  'jeepneyUserList.sourceTypePointsExchange': 'Points Exchange',
  'jeepneyUserList.transactionTypeAll': 'All',
  'jeepneyUserList.transactionTypeIncome': 'Income',
  'jeepneyUserList.transactionTypeExpense': 'Expense',
  'jeepneyUserList.cashRewardTotal': 'Cash Reward - Total',
  'jeepneyUserList.cashRewardDistributed': 'Cash Reward - Distributed',
  'jeepneyUserList.cashRewardDistributedTooltip': 'Actual Activity Cost',
  'jeepneyUserList.cashRewardTotalTooltip': 'Total cash ever won, including amounts cleared by abandoning or failed settlement. Not the payable amount.',
  'jeepneyUserList.currentRoundPendingCash': 'Current Round Pending',
  'jeepneyUserList.currentRoundPendingCashTooltip': 'Won in the current round but not yet paid out. Paid only on successful settlement; cleared if abandoned or settlement fails.',
  'jeepneyUserList.totalPointsEarned': 'Total Points Earned',
  'jeepneyUserList.totalSpinTicketsEarned': 'Total Spin Tickets',
  'jeepneyUserList.returnRate': 'Return Rate',
  'jeepneyUserList.operation': 'Operation',
  'jeepneyUserList.rewardDetail': 'Reward Detail',
  'jeepneyUserList.search': 'Search',
  'jeepneyUserList.reset': 'Reset',
  'jeepneyUserList.export': 'Export',
  'jeepneyUserList.exportLoading': 'Exporting data...',
  'jeepneyUserList.exportSuccess': 'Export successful',
  'jeepneyUserList.exportFail': 'Export failed',
  'jeepneyUserList.hourlyUpdate': 'Updated hourly',
  'jeepneyUserList.totalActivityCost': 'Total Activity Cost',
  'jeepneyUserList.totalReturnRate': 'Total Return Rate',
  // Import Log Management
  'importLog.title': 'Import Log Management',
  'importLog.fileName': 'File Name',
  'importLog.fileNamePlaceholder': 'Enter file name',
  'importLog.createTime': 'Submit Time',
  'importLog.completeTime': 'Complete Time',
  'importLog.totalCount': 'Total',
  'importLog.successCount': 'Success',
  'importLog.failCount': 'Failed',
  'importLog.status': 'Status',
  'importLog.statusPending': 'Processing',
  'importLog.statusComplete': 'Completed',
  'importLog.action': 'Action',
  'importLog.viewDetail': 'View Detail',
  'importLog.search': 'Search',
  'importLog.reset': 'Reset',
  'importLog.requestFailed': 'Query failed',
  'importLog.detail.title': 'Import Detail',
  'importLog.detail.close': 'Close',
  'importLog.detail.loading': 'Loading...',
  'importLog.detail.headerFileName': 'Import File Name',
  'importLog.detail.headerOperator': 'Operator',
  'importLog.detail.headerCreateTime': 'Submit Time',
  'importLog.detail.headerCompleteTime': 'Complete Time',
  'importLog.detail.headerStatus': 'Import Status',
  'importLog.detail.memberAccount': 'Member Account',
  'importLog.detail.memberAccountPlaceholder': 'Search failed username',
  'importLog.detail.failureReason': 'Failure Reason',
  'importLog.detail.failureTitle': 'Failure Details',
  'importLog.detail.hint': 'Note: Only failed user accounts within the last month are retained',
  'importLog.detail.noFailedRecords': 'No failed records',
  'importLog.detail.noRecords': 'No import records',

  // Negative Profit Member List Page
  'negativeProfitMember.title': 'Negative Profit Member List',
  'negativeProfitMember.dateRangeHint': 'Default yesterday, query results are a summary of data for the selected date range (History = excluding today)',
  'negativeProfitMember.hint': '(At least one query condition must be filled except time filter)',
  'negativeProfitMember.dateRange': 'Statistics Date',
  'negativeProfitMember.selectVipLevel': 'Please select VIP level',
  'negativeProfitMember.selectAll': 'Select All',
  'negativeProfitMember.curDataPkCode': 'Judgment Currency',
  'negativeProfitMember.curDataPkCodeRequired': 'Please select judgment currency',
  'negativeProfitMember.selectCurDataPkCode': 'Please select judgment currency',
  'negativeProfitMember.lossThreshold': 'Loss Threshold ≥',
  'negativeProfitMember.lossThresholdPlaceholder': 'Minimum net loss 100',
  'negativeProfitMember.memberAccount': 'Member Account',
  'negativeProfitMember.memberAccountPlaceholder': 'Please enter member account',
  'negativeProfitMember.vipLevel': 'VIP Level',
  'negativeProfitMember.agentAccount': 'Superior Agent Account',
  'negativeProfitMember.agentAccountPlaceholder': 'Please enter superior agent account',
  'negativeProfitMember.minDepositCount': 'Historical Deposit Count',
  'negativeProfitMember.minDepositCountPlaceholder': 'Please enter deposit count',
  'negativeProfitMember.minDepositAmount': 'Historical Deposit Amount',
  'negativeProfitMember.minDepositAmountPlaceholder': 'Please enter deposit amount',
  'negativeProfitMember.minWithdrawCount': 'Historical Withdraw Count',
  'negativeProfitMember.minWithdrawCountPlaceholder': 'Please enter withdraw count',
  'negativeProfitMember.minWithdrawAmount': 'Historical Withdraw Amount',
  'negativeProfitMember.minWithdrawAmountPlaceholder': 'Please enter withdraw amount',
  'negativeProfitMember.loginChannel': 'Login Terminal',
  'negativeProfitMember.selectLoginChannel': 'Please select login terminal',
  'negativeProfitMember.registerInfo': 'Registration Info',
  'negativeProfitMember.registerTime': 'Registration Time',
  'negativeProfitMember.registerIp': 'Registration IP',
  'negativeProfitMember.realName': 'Real Name',
  'negativeProfitMember.nickname': 'Nickname',
  'negativeProfitMember.depositCount': 'Historical Deposit Count',
  'negativeProfitMember.withdrawCount': 'Historical Withdraw Count',
  'negativeProfitMember.depositAmount': 'Historical Total Deposit (Multi-Currency)',
  'negativeProfitMember.withdrawAmount': 'Historical Total Withdraw (Multi-Currency)',
  'negativeProfitMember.depositWithdrawDiff': 'Historical Deposit-Withdraw Difference (Multi-Currency)',
  'negativeProfitMember.bettingAmount': 'Historical Total Betting (Multi-Currency)',
  'negativeProfitMember.profitLoss': 'Historical Total Win/Loss (Multi-Currency)',
  'negativeProfitMember.totalProfitLoss': 'Cumulative Total Win/Loss (Multi-Currency)',
  'negativeProfitMember.lastLoginTime': 'Last Login Time',
  'negativeProfitMember.requestFailed': 'Query failed',
  'negativeProfitMember.exportSuccess': 'Export successful',
  'negativeProfitMember.exportFailed': 'Export failed'
};
